import React from "react";
import Context from "../../../Context";
import CartButton from "../../Misc/Cart/CartButton";
import SuperSelect from "../../Misc/SuperSelect";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import Blocker from "../../Misc/Blocker";
import ProductTurnover from "./ProductTurnover";
import ProductPlace from "./ProductPlace";
import List from "../../Misc/List";
import ProductListItem from "./ProductListItem";
import EssenceReferenceStorageEdit from "../../Essence/EssenceReferenceStorageEdit";
import ProductDocumentDropdown from "./ProductDocumentDropdown";
import ModelInfo from "./ModelInfo";
import Searchbox from "../../Misc/Searchbox";
import Select from "react-select";

export default class Product extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,

      item: {},
      lines: [],
      filters: [],

      turnover: false,
      place: false,
      info: false,

      currentItem: {},
      customListKey: "",

      searchText: "",
      searchRack: "",
      searchCell: "",

      racks: [],
      cells: [],
    };
  }

  componentDidMount() {
    this.setDefaultFilters();
    this.loadReferences();
    this.renderButtons();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.storageId !== this.props.storageId) {
      this.setDefaultFilters();
      this.loadReferences();
    }
    this.renderButtons();
  }

  loadReferences = async () => {
    let racks = [];
    let cells = [];

    if (this.props.storageId) {
      this.setState({ pending: true });
      let results = await this.context.api.qa("/product/list", {
        groupby: ["rack", "cell"],
        fields: ["rack", "cell"],
        filter: { storage: this.props.storageId },
      });
      racks = results.reduce((racks, v) => {
        if (!racks.find((k) => k.value === v.rack)) {
          racks.push({
            label: v.rack,
            value: v.rack,
          });
        }
        return racks;
      }, []);
      cells = results.reduce((cells, v) => {
        if (!cells.find((k) => k.value === v.cell)) {
          cells.push({
            label: v.cell,
            value: v.cell,
          });
        }
        return cells;
      }, []);
    }

    this.setState({
      pending: false,
      racks,
      cells,
    });
  };
  setDefaultFilters = () => {
    this.setState(({ searchText, searchRack, searchCell }) => {
      let filters = [];

      filters.push({
        field: "storage",
        compare: "EQL",
        value: this.props.storageId,
      });

      if (searchText) {
        filters.push({
          lstr: "(",
          field: "label",
          compare: "IKE",
          value: `%${searchText}%`,
        });
        filters.push({
          rstr: ")",
          field: "modelcode",
          compare: "IKE",
          value: `%${searchText}%`,
          condition: "OR"
        });
      }

      if (searchRack) {
        filters.push({
          field: "rack",
          value: searchRack,
        });
      }

      if (searchCell) {
        filters.push({
          field: "cell",
          value: searchCell,
        });
      }

      return { filters };
    });
  };

  renderButtons = () => {
    this.context.actionsSet(
      <>
        <ProductDocumentDropdown context={this.context} />
        <CartButton context={this.context} />
      </>
    );
  };

  onStorageChange = (value) => {
    if (this.props.onStorageChange) {
      this.props.onStorageChange(value);
      return;
    }
    this.context.replace(`/product/${value}`);
  };

  onTurnoverOpen = (id, item) => {
    this.setState({ turnover: id, currentItem: item });
  };
  onTurnoverClose = (id) => {
    this.setState({ turnover: false, currentItem: {} });
  };
  onPlaceOpen = (id, item) => {
    this.setState({ place: id, currentItem: item });
  };
  onInfoOpen = (id, item) => {
    this.setState({ info: id, currentItem: item });
  };
  onInfoClose = () => {
    this.setState({ info: false, currentItem: {} });
  };
  onPlaceClose = () => {
    this.setState({ place: false, currentItem: {} });
  };
  onPlaceChange = () => {
    this.setState({ customListKey: this.context.key() }, () =>
      this.loadReferences()
    );
  };

  onListLoadStart = () => {
    this.setState({ pending: true });
  };
  onListLoadEnd = () => {
    this.setState({ pending: false });
  };

  onCartAdd = async (id) => {
    if (id) {
      this.setState({ pending: true });
      let result = await this.context.cart.addItem(id);
      if (result === false) {
        this.context.toast("Не удалось добавить в подборку", "error");
      } else {
        this.context.toast("Добавлено в подборку", "success");
      }
      this.context.force();
      this.setState({ pending: false });
    }
  };

  handleSearch = (searchText) => {
    this.setState(
      {
        searchText,
      },
      () => this.setDefaultFilters()
    );
  };

  render() {
    const {
      pending,
      turnover,
      currentItem,
      place,
      info,
      racks,
      searchRack,
      cells,
      searchCell,
    } = this.state;

    return (
      <>
        {!this.props.onProductPick && (
          <CrumbsProvider title="Складские запасы" link="/product/" />
        )}
        {turnover && (
          <ProductTurnover
            product={turnover}
            item={currentItem}
            onHide={this.onTurnoverClose}
          />
        )}
        {place && (
          <ProductPlace
            product={place}
            item={currentItem}
            onHide={this.onPlaceClose}
            onAfterSave={this.onPlaceChange}
          />
        )}
        {info && (
          <ModelInfo
            id={currentItem.model}
            label={currentItem.modelname}
            description={currentItem.modeldescription}
            onHide={this.onInfoClose}
          />
        )}
        <Blocker on={pending}>
          <div className="mb-4 pb-4 border-bottom">
            <div className="row">
              <div className="col-12 mb-3">
                <SuperSelect
                  grey
                  defaultValue={this.props.storageId}
                  onChange={(value) => this.onStorageChange(value)}
                  onSingleItem={(item) => this.onStorageChange(item.value)}
                  essence="storage"
                  placeholder="Выберите место хранения..."
                  nameField="name"
                  extraFields={["shipname"]}
                  formatOptionLabel={(option) => (
                    <span>
                      {option.label}
                      {option.shipname && (
                        <span className="text-muted  text-small font-italic ml-2">
                          {option.shipname}
                        </span>
                      )}
                    </span>
                  )}
                  idField="id"
                  reference={{
                    title: "Места хранения",
                    essence: "storage",
                    showDescription: true,
                    showType: true,
                    itemEditor: (itemEditorProps) => (
                      <EssenceReferenceStorageEdit {...itemEditorProps} />
                    ),
                  }}
                />
              </div>
              <div className="col-lg-6">
                <Searchbox onSearch={this.handleSearch} />
              </div>
              <div className="col-lg-3">
                <Select
                  value={this.context.api.getReferenceValue(searchRack, racks)}
                  onChange={(option) =>
                    this.setState({ searchRack: option?.value || "" }, () =>
                      this.setDefaultFilters()
                    )
                  }
                  className="from-control react-select react-select-grey"
                  classNamePrefix="react-select-inner"
                  options={racks}
                  placeholder={"Полка..."}
                  noOptionsMessage={() => "Ничего не найдено"}
                  isClearable
                />
              </div>
              <div className="col-lg-3">
                <Select
                  value={this.context.api.getReferenceValue(searchCell, cells)}
                  onChange={(option) =>
                    this.setState({ searchCell: option?.value || "" }, () =>
                      this.setDefaultFilters()
                    )
                  }
                  className="from-control react-select react-select-grey"
                  classNamePrefix="react-select-inner"
                  options={cells}
                  placeholder={"Ячейка..."}
                  noOptionsMessage={() => "Ничего не найдено"}
                  isClearable
                />
              </div>
            </div>
          </div>

          {this.state.filters?.length && (
            <List
              listKey="ProductList"
              key={this.state.customListKey}
              search={JSON.stringify(this.state.filters)}
              limit={50}
              hideSinglePageNav={true}
              keyField="id"
              path="/product/list"
              row={this.state.viewGrid}
              blocker={{ spinnerFixed: true, hAuto: true }}
            >
              <ProductListItem
                onProductPick={this.props.onProductPick}
                onPlaceOpen={this.onPlaceOpen}
                onInfoOpen={this.onInfoOpen}
                onTurnoverOpen={this.onTurnoverOpen}
                onCartAdd={this.onCartAdd}
              />
            </List>
          )}
        </Blocker>
      </>
    );
  }
}
